import { render, staticRenderFns } from "./TextContent.vue?vue&type=template&id=848545cc&scoped=true&"
import script from "./TextContent.vue?vue&type=script&lang=ts&"
export * from "./TextContent.vue?vue&type=script&lang=ts&"
import style0 from "./TextContent.vue?vue&type=style&index=0&id=848545cc&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848545cc",
  null
  
)

export default component.exports